import gsap from 'gsap';
import barba from '@barba/core';

export default {

	selectors: {
		header: 'header.header',
		menuToggle: '.js-menu',
		menu: '#menu',
		menuInner: '#menu > div',
		logo: '.header__logo',
	},

	classes: {
		hide: 'hide',
		hamburgerActive: 'is-active',
		hidden: 'hidden',
		menuActive: 'header--menu-active',
		scrolled: 'header--scrolled',
	},

	scrollThreshold: 300,

	lastScrollTop: 0,

	init() {
		this.header = document.querySelector(this.selectors.header);
		this.menuToggle = document.querySelector(this.selectors.menuToggle);
		this.menu = document.querySelector(this.selectors.menu);
		this.menuInner = document.querySelector(this.selectors.menuInner);
		this.logo = document.querySelector(this.selectors.logo);
		this.scroll = this.scroll.bind(this);
		this.toggleMenu = this.toggleMenu.bind(this);
		document.addEventListener('scroll', this.scroll);
		this.menuToggle.addEventListener('click', this.toggleMenu);
		barba.hooks.beforeLeave(() => {
			this.closeMenu();
		});
	},

	scroll() {
		this.header.classList.toggle(
			this.classes.hide,
			this.scrollDown() && window.scrollY > this.scrollThreshold,
		);
		this.header.classList.toggle(
			this.header.dataset.headerBg,
			window.scrollY > this.scrollThreshold,
		);
		this.header.classList.toggle(
			this.classes.scrolled,
			window.scrollY > this.scrollThreshold,
		);
	},

	scrollDown() {
		const st = window.pageYOffset || document.documentElement.scrollTop;
		const down = st > this.lastScrollTop;
		this.lastScrollTop = st <= 0 ? 0 : st;
		return down;
	},

	toggleMenu() {
		if (this.header.classList.contains(this.classes.menuActive)) {
			this.closeMenu();
		} else {
			this.openMenu();
		}
	},

	openMenu() {
		this.header.classList.add(this.classes.menuActive);
		this.menuToggle.innerHTML = 'Close';
		document.querySelector('body').classList.add('overflow-hidden');

		const timeline = gsap.timeline();
		timeline.set(this.menuInner, { alpha: 0 });
		timeline.fromTo(this.menu, { y: '-100%', display: 'block' }, { y: 0, duration: 0.5 });
		timeline.fromTo(this.menuInner, { alpha: 0 }, { alpha: 1, duration: 0.5 });
		this.header.dispatchEvent(new CustomEvent('menu-opened'));
	},

	closeMenu() {
		this.menuToggle.innerHTML = 'Menu';
		document.querySelector('body').classList.remove('overflow-hidden');

		setTimeout(() => {
			this.header.classList.remove(this.classes.menuActive);
		}, 650);
		const timeline = gsap.timeline();
		timeline.to(this.menuInner, { alpha: 0, duration: 0.5 });
		timeline.to(this.menu, { y: '-100%', duration: 0.5 });
		timeline.set(this.menu, { display: 'none' }).then(() => {
			this.header.dispatchEvent(new CustomEvent('menu-closed'));
		});
	},

};
